import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

interface Props {
  hasEventMap: boolean;
}

export const useStyles = makeStyles<Theme, Props>((theme) => ({
  imageThumbnail: {
    position: "relative",
    border: "1px solid #eaeaea",
    borderRadius: "10px",
    width: theme.spacing(7.5),
    minWidth: theme.spacing(7.5),
    height: theme.spacing(5.5),
    margin: "8px 10px",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      minWidth: theme.spacing(4),
      margin: "5px",
    },
    "& img": {
      objectFit: "cover",
      width: "inherit",
      height: "inherit",
      [theme.breakpoints.down("md")]: {
        width: theme.spacing(4),
        height: theme.spacing(4),
      },
    },
    "&:hover button": {
      display: "block",
    },
  },
  maximizeBtn: {
    display: "none",
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    color: "white",
    borderRadius: 0,
    background: "rgb(0 0 0 / 40%)",
  },
  mapBannerText: {
    fontSize: theme.spacing(2.25),
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    margin: theme.spacing(1.25),
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginLeft: "2px",
    },
  },
  title: {
    display: "-webkit-box",
    overflow: "hidden",
    fontSize: theme.spacing(1.125),
    minWidth: theme.spacing(16.25),
    wordBreak: "normal",
    width: theme.spacing(50),
    textOverflow: "ellipsis",
    WebkitLineClamp: 4, // 4 lines was chosen as a balance between number of chatacters shown across devices without squashing the UI
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.up("md")]: {
      fontSize: theme.spacing(1.875),
      width: theme.spacing(45),
    },
    [theme.breakpoints.down("md")]: {
      whiteSpace: "unset",
      width: ({ hasEventMap }) => (hasEventMap ? "100%" : theme.spacing(18)),
      minWidth: ({ hasEventMap }) => theme.spacing(hasEventMap ? 9 : 13),
    },
  },
}));
